import { createFileRoute } from "@tanstack/react-router";
import AdminGuide from "@/pages/AdminGuide";

export const Route = createFileRoute("/admin/guide/")({
  component: AdminGuide,
});
